import React from "react";

export const MdArrowDropleft = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M320 128L192 256l128 128z"/></svg>) as JSX.Element;
